// extracted by mini-css-extract-plugin
module.exports = {"header":"_3ioV2wC7","paper":"_1edJaSL1","container":"_14671xVA"};